import React from 'react';
import { Card, Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';

const CancelPage = () => {
  const navigate = useNavigate();

  return (
    <>
      <SEO
        title="Payment Cancelled - Osailu"
        description="Your payment was cancelled. You can try again anytime."
        url="/cancel"
        noindex={true}
      />
      <div style={{ 
        minHeight: 'calc(100vh - 120px)', 
        backgroundColor: 'var(--bg-color)',
        color: 'var(--text-color)',
        transition: 'background-color 0.3s ease, color 0.3s ease',
        padding: '20px 0'
      }}>
      <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <Card>
            <Card.Header>
              <h4 className="mb-0">❌ Payment Cancelled</h4>
            </Card.Header>
            <Card.Body>
              <Alert variant="warning" className="mb-4">
                <Alert.Heading>No worries!</Alert.Heading>
                <p>
                  Your payment was cancelled. You can try again anytime or contact support if you need help.
                </p>
              </Alert>

              <div className="mb-4">
                <h5>What's next?</h5>
                <ul>
                  <li>You can try subscribing again when you're ready</li>
                  <li>Contact our support team if you encountered any issues</li>
                  <li>Explore our free features in the meantime</li>
                </ul>
              </div>

              <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                <Button 
                  variant="outline-secondary" 
                  onClick={() => navigate('/userManagement')}
                >
                  Back to Account
                </Button>
                <Button 
                  variant="primary" 
                  onClick={() => navigate('/')}
                >
                  Go to Dashboard
                </Button>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
    </div>
    </>
  );
};

export default CancelPage;
